import React, {useCallback, useMemo} from "react";
import "./index.scss";
import {LoggedInLayout} from "features/layouts/pages/logged-in";
import {connect} from "react-redux";
import {LoadingLogoPortal} from "features/components/loading-logo";
import Text from "features/components/text";
import {__} from "services/i18n";
import {
    singleDirectoryData,
    singleDirectoryErrorSelector,
    singleDirectoryLoading
} from "features/pages/single-directory/selectors";
import {startSingleDirectory} from "features/pages/single-directory/reducer";
import {withToastManager} from "react-toast-notifications";
import Title from "features/components/title";
import {MaterialBox} from "features/components/material-box";
import VideoCard from "features/components/video-card";
import {ResourcePaymentSection} from "features/components/resource-payment-section";
import {historyObject} from "historyObject";
import SuggestedResource from "features/components/suggested";
import {SpeakerBox} from "features/components/speakers";
import {CategoryTagBox} from "features/components/category-tag-box";
import {ReportAProblemButton} from "features/components/problem-button";
import {useMediaQuery} from "services/utils/utils";
import {MOBILE_MEDIA_QUERY_THRESHOLD} from "constants.js";

/* istanbul ignore next */
const mapStateToProps = state => ({
    directory: singleDirectoryData(state),
    loading: singleDirectoryLoading(state),
    error: singleDirectoryErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    startSingleDirectory
};

export const SingleDirectoryPage = (props) => {
    const {directory, loading, error} = props;
    const {startSingleDirectory} = props;

    React.useEffect(() => {
        startSingleDirectory({id: props.match.params.id})
    }, [props.match.params.id, startSingleDirectory]);

    React.useEffect(() => {
        if(!error.inError) return;
        props.toastManager.add(__(error.error), { appearance: 'error', id: 'error-load-single-directory-toast'});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD);

    const breadcrumbTitle = useMemo(() => {
        if (isMobile) return "single-directory.breadcrumb";
        return directory ? directory.name : "single-directory.breadcrumb"
    }, [directory, isMobile]);

    const goToPayment = useCallback(() => {
        historyObject.push(`/payment/directory/${directory.id}`);
    }, [directory]);

    const renderContent = useCallback(() => {
        if(loading) {
            return <LoadingLogoPortal />;
        }
        if(!directory) {
            return <Text size={16} align={"center"}>{__("single-directory.not-found")}</Text>
        }
        return <><div className={"wrapper"}>
            <div className={"directory-top"}>
                <div className="directory-data">
                    <Text size={16}>{__("common.directory.data", [{key: "[count]", value: directory.video_number}, {key: "[duration]", value: directory.total_duration}])}</Text>
                    <Title size={34}>{directory.name}</Title>
                    {(!!directory.categories.length || !!directory.tags.length) && <CategoryTagBox categories={directory.categories} tags={directory.tags} />}
                    {directory.speakers && <SpeakerBox speakers={directory.speakers} />}
                </div>
                <img src={directory.image} alt={"directory"}/>
            </div>
            <ResourcePaymentSection data={directory} goToPayment={goToPayment} type={"directory"} />
            <div className="sidebar-wrapper">
                <div className={"content"}>
                    <Title size={28}>{__("single-directory.content")}</Title>
                    <div className="videos">
                        {directory.videos.map(video => <VideoCard key={video.id} video={video} />)}
                    </div>
                </div>
                <div className="sidebar">
                    <Title size={24}>{__("single-directory.description.title")}</Title>
                    <Text size={16}>{directory.description}</Text>
                    {(directory.material && directory.material.length > 0) && <MaterialBox data={directory.material} locked={directory.requires_payment} />}
                    <ReportAProblemButton />
                </div>
            </div>
        </div>
        <SuggestedResource type={"directory"} resource_id={directory.id} />
        </>;
    }, [directory, goToPayment, loading]);

    return <LoggedInLayout
        type={"light"}
        className={"single-directory-page"}
        breadcrumbs={[{title: "common.home-breadcrumb", link:"/"}, {title: "videos.breadcrumb", link: "/videos"}, {title: breadcrumbTitle}]}>
        {renderContent()}
    </LoggedInLayout>
};
SingleDirectoryPage.propTypes = {

};
export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(SingleDirectoryPage));